export const funcaoIndisponivel = (el) => {
  el.$showModal({
    title: 'Função indisponível',
    text:
      'Esta função está disponível apenas para consultores que contrataram o serviço de whitelabel. Para mais informações entre em contato com nossa equipe.',
    buttons: [
      {
        text: 'Voltar',
        class: { underlined: true },
      },
      {
        text: 'Contratar whitelabel',
        class: { primary: true },
        action: () => {
          if (el.$route.name !== 'contrato') {
            el.$router.push({ name: 'contrato' })
          }
        },
      },
    ],
  })
}
